/** Channel the calling summary is being recorded for. */
export enum CallSummaryMode {
  CALL = "call",
  FAX = "fax",
}

/** Tab label for each channel, also shown as the Second STP Outcome value. */
export const CALL_SUMMARY_MODE_LABELS: Record<CallSummaryMode, string> = {
  [CallSummaryMode.CALL]: "Call",
  [CallSummaryMode.FAX]: "Fax",
};

export const CALL_SUMMARY_MODE_TABS = [
  {
    id: CallSummaryMode.CALL,
    label: CALL_SUMMARY_MODE_LABELS[CallSummaryMode.CALL],
  },
  {
    id: CallSummaryMode.FAX,
    label: CALL_SUMMARY_MODE_LABELS[CallSummaryMode.FAX],
  },
];
